interface Props {
  currentStep: number;
  totalSteps: number;
}

export default ({ currentStep, totalSteps }: Props) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center gap-2" aria-label={`Step ${currentStep} of ${totalSteps}`}>
      {steps.map((step, index) => {
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        const dotClass = isCompleted
          ? "bg-emerald-500"
          : isActive
            ? "bg-indigo-600 ring-4 ring-indigo-100"
            : "bg-slate-200";
        const lineClass = step < currentStep ? "bg-emerald-500" : "bg-slate-200";

        return (
          <div key={step} className="flex items-center">
            <span className={`block h-2.5 w-2.5 rounded-full transition ${dotClass}`} />
            {index < steps.length - 1 && <span className={`h-px w-8 transition ${lineClass}`} />}
          </div>
        );
      })}
    </div>
  );
};
